function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.94576 13.2251C11.2395 13.2251 13.9096 10.555 13.9096 7.26131C13.9096 3.96758 11.2395 1.29749 7.94576 1.29749C4.65203 1.29749 1.98194 3.96758 1.98194 7.26131C1.98194 10.555 4.65203 13.2251 7.94576 13.2251ZM7.94576 14.5031C11.9453 14.5031 15.1875 11.2608 15.1875 7.26131C15.1875 3.26178 11.9453 0.0195312 7.94576 0.0195312C3.94623 0.0195312 0.703979 3.26178 0.703979 7.26131C0.703979 11.2608 3.94623 14.5031 7.94576 14.5031Z",
  fill: "#0A7E85"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.1798 11.4953C12.4293 11.2458 12.8339 11.2458 13.0834 11.4953L17.3433 15.7552C17.5928 16.0047 17.5928 16.4093 17.3433 16.6589C17.0938 16.9084 16.6892 16.9084 16.4396 16.6589L12.1798 12.399C11.9302 12.1495 11.9302 11.7449 12.1798 11.4953Z",
  fill: "#0A7E85"
});

function SvgMagnifyingGlass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlass);
export default __webpack_public_path__ + "static/media/MagnifyingGlass.41de20bf.svg";
export { ForwardRef as ReactComponent };